import { render, staticRenderFns } from "./CreateTransfer.vue?vue&type=template&id=6d12b88b&"
import script from "./CreateTransfer.vue?vue&type=script&lang=js&"
export * from "./CreateTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports